module.exports = __webpack_public_path__ + "img/technology.e5118d56.svg";